export default __webpack_public_path__ + "static/media/Hot-Mop-Balconies.dc346cea.jpg";